export default __webpack_public_path__ + "static/media/exam_edition_2.59433b49.jpg";